import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  OnChanges,
} from '@angular/core';
import { createRoot } from 'react-dom/client';
import * as React from 'react';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { ReactProvider } from '@shared/react-components/react-provider';
import { MenusPage } from './menus.page';
import { AuthService } from '@core/services/auth.service';

@Component({
  selector: 'app-menus-react',
  template: '<div class="h-full w-full" #reactRoot></div>',
})
export class MenusReactWrapperComponent
  implements OnInit, OnDestroy, OnChanges
{
  @ViewChild('reactRoot', { static: true }) containerRef!: ElementRef;

  private root: any;
  private organizationId?: number;
  private siteId?: number;
  private routeSubscription: Subscription;
  private authSubscription?: Subscription;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    this.root = createRoot(this.containerRef.nativeElement);

    // Get organization ID from route params
    this.routeSubscription = this.route.parent?.params.subscribe((params) => {
      const maybeOrgId = params['orgId'];
      const maybeSiteId = params['siteId'];

      if (maybeOrgId) {
        this.organizationId = +maybeOrgId;
      }

      if (maybeSiteId) {
        this.siteId = +maybeSiteId;
      }

      this.render();
    }) || new Subscription();

    // If no organizationId from route (site view), fall back to current user
    if (!this.organizationId) {
      this.authSubscription = this.authService.user.subscribe((user) => {
        if (user?.organization?.id) {
          this.organizationId = user.organization.id;
          this.render();
        }
      });
    }
  }

  ngOnChanges(): void {
    if (!this.root) return;
    this.render();
  }

  ngOnDestroy() {
    if (this.root) {
      this.root.unmount();
    }
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }

  private render() {
    if (!this.root) {
      return;
    }
    this.root.render(
      React.createElement(
        ReactProvider,
        null,
        React.createElement(MenusPage, {
          organizationId: this.organizationId,
          siteId: this.siteId,
        }),
      ),
    );
  }
}
